import { EmptyView, EmptyViewButton } from '~components/EmptyView';
import { EmptyPlaylistIllustration } from '~components/ui/illustrations';

export function EmptyPlaylists({ onCreate }: { onCreate: () => void }) {
  return (
    <EmptyView icon={<EmptyPlaylistIllustration />} title="Create your first playlist">
      <EmptyViewButton onClick={onCreate} label="Create playlist" />
    </EmptyView>
  );
}
